module.exports = __webpack_public_path__ + "img/robot_img.d43e9fb1.9718eb49.png";